import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@trukt/ui/Page';
import PageContainer from '../shared/components/Layouts/PageContainer';
import AdminView from '../admin/AdminView';
const Component = () => (
  <Page route={{ Component: AdminView, title: 'Admin', Container: PageContainer }} />
);
export const Route = createFileRoute('/admin/')({ component: Component });
